import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdBuildings = z.any()
export type TagsGetMunicipalities_municipalityIdBuildings = z.infer<typeof tagsGetMunicipalities_municipalityIdBuildings>

export const paramsGetMunicipalities_municipalityIdBuildings = z.object({ "municipalityId": z.string() })
export type ParamsGetMunicipalities_municipalityIdBuildings = z.infer<typeof paramsGetMunicipalities_municipalityIdBuildings>

export const responseGetMunicipalities_municipalityIdBuildings = z.object({ "payload": z.array(z.object({ "id": z.string(), "name": z.string(), "municipalityId": z.string(), "address": z.string().optional(), "createdAt": z.string().optional(), "updatedAt": z.string().optional(), "image": z.string().optional() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetMunicipalities_municipalityIdBuildings = z.infer<typeof responseGetMunicipalities_municipalityIdBuildings>

interface IGetMunicipalities_municipalityIdBuildings extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdBuildings,
  params: ParamsGetMunicipalities_municipalityIdBuildings,
  response: ResponseGetMunicipalities_municipalityIdBuildings
}
export const tagsPostMunicipalities_municipalityIdBuildings = z.any()
export type TagsPostMunicipalities_municipalityIdBuildings = z.infer<typeof tagsPostMunicipalities_municipalityIdBuildings>

export const paramsPostMunicipalities_municipalityIdBuildings = z.object({ "municipalityId": z.string() })
export type ParamsPostMunicipalities_municipalityIdBuildings = z.infer<typeof paramsPostMunicipalities_municipalityIdBuildings>

export const bodyPostMunicipalities_municipalityIdBuildings = z.object({ "name": z.string().min(1), "address": z.string().optional() })
export type BodyPostMunicipalities_municipalityIdBuildings = z.infer<typeof bodyPostMunicipalities_municipalityIdBuildings>

export const responsePostMunicipalities_municipalityIdBuildings = z.object({ "payload": z.object({ "id": z.string(), "name": z.string(), "municipalityId": z.string(), "address": z.string().optional(), "createdAt": z.string().optional(), "updatedAt": z.string().optional(), "image": z.string().optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostMunicipalities_municipalityIdBuildings = z.infer<typeof responsePostMunicipalities_municipalityIdBuildings>

interface IPostMunicipalities_municipalityIdBuildings extends BaseMethodType {
  tags: TagsPostMunicipalities_municipalityIdBuildings,
  params: ParamsPostMunicipalities_municipalityIdBuildings,
  body: BodyPostMunicipalities_municipalityIdBuildings,
  response: ResponsePostMunicipalities_municipalityIdBuildings
}
export const URL = '/municipalities/:municipalityId/buildings'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdBuildings,
    params: paramsGetMunicipalities_municipalityIdBuildings,
    response: responseGetMunicipalities_municipalityIdBuildings
  },
  post: {
    tags: tagsPostMunicipalities_municipalityIdBuildings,
    params: paramsPostMunicipalities_municipalityIdBuildings,
    body: bodyPostMunicipalities_municipalityIdBuildings,
    response: responsePostMunicipalities_municipalityIdBuildings
  }
}
export interface Municipalities_municipalityIdBuildings extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdBuildings,
  post: IPostMunicipalities_municipalityIdBuildings
}